// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";

const productsUrl = "/api/v2/products";

export interface GetFeaturedProductsApiParameter extends ApiParameter {
    productNumbers: string;
    page?: number;
    pageSize?: number;
}

export async function getFeaturedProducts(
    parameter: GetFeaturedProductsApiParameter,
): Promise<ServiceResult<ProductCollectionModel>> {
    try {
        const featuredProducts = await get<ProductCollectionModel>(
            `${productsUrl}/?${parameter.productNumbers}&pageSize=${parameter.pageSize}&page=${parameter.page}`,
        );
        return {
            result: featuredProducts,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.message,
        };
    }
}
